import { useSelector } from 'react-redux';
import { useQueryBonuses } from '../../../hooks/API/useQueryBonuses';
import { viewedCampaignIdsSelector } from '../../../redux/reducers/app/storage';
import { AVAILABLE } from '../../../constants/bonuses';

export const useBonusesPictogram = () => {
  const viewedCampaignIds = useSelector(viewedCampaignIdsSelector);
  const { isLoading, isError, data } = useQueryBonuses();

  if (isLoading || isError) {
    return false;
  }

  const hasNewCampaigns = data
    .filter(({ isCampaign, status }) => isCampaign && status === AVAILABLE)
    .some((campaign) => !viewedCampaignIds.has(campaign.id));

  return hasNewCampaigns;
};
